import { useMemo } from "react";
import useMainMenuContext from "./useMainMenuContext.js";
const useScreenLgBreakpoint = (isMainMenuLight = false)=>{
    const { embeddedIn, currentBreakpointKey, layoutConfig } = useMainMenuContext();
    const isEmbeddedInNewDashboard = 'new-dashboard' === embeddedIn;
    const isLg = useMemo(()=>{
        if (isEmbeddedInNewDashboard) {
            const defaultEmbeddedInBreakpoints = [
                'md',
                'lg',
                'xl'
            ];
            const embeddedInBreakpoints = layoutConfig.embeddedInBreakpoints || defaultEmbeddedInBreakpoints;
            return embeddedInBreakpoints.includes(currentBreakpointKey);
        }
        return isMainMenuLight ? 'md' === currentBreakpointKey : 'lg' === currentBreakpointKey;
    }, [
        currentBreakpointKey,
        isEmbeddedInNewDashboard,
        isMainMenuLight
    ]);
    return {
        isLg,
        isEmbeddedInNewDashboard
    };
};
const hooks_useScreenLgBreakpoint = useScreenLgBreakpoint;
export default hooks_useScreenLgBreakpoint;
